import { buildBrandCssVars } from './colorUtils';
import { CompanyBrand, normalizeCompanyBrand } from './types';

export const applyBrandTheme = (brand: CompanyBrand): CompanyBrand => {
  const resolved = normalizeCompanyBrand(brand);
  const cssVars = buildBrandCssVars(resolved.primaryColor, resolved.shellBackgroundColor);
  const root = document.documentElement;

  Object.entries(cssVars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  return resolved;
};

export const readCachedBrand = (): CompanyBrand | null => {
  try {
    const raw = localStorage.getItem('student_brand');
    if (!raw) return null;
    return normalizeCompanyBrand(JSON.parse(raw) as CompanyBrand);
  } catch {
    return null;
  }
};

export const cacheBrand = (brand: CompanyBrand): void => {
  localStorage.setItem('student_brand', JSON.stringify(normalizeCompanyBrand(brand)));
};

export const readCachedCompanySlug = (): string | null => {
  const slug = localStorage.getItem('student_company_slug');
  return slug?.trim() || null;
};

export const cacheCompanySlug = (slug: string | null): void => {
  if (!slug?.trim()) {
    localStorage.removeItem('student_company_slug');
    return;
  }
  localStorage.setItem('student_company_slug', slug.trim().toLowerCase());
};

export const clearBrandCache = (): void => {
  localStorage.removeItem('student_brand');
  localStorage.removeItem('student_company_slug');
};
